// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"76f7c788","368":"d9687dd3","420":"e8adec56","539":"b3111e1b","541":"e6e0dfa9","644":"7e78ad41","857":"888d35e9","884":"0fd4a4d6","945":"ecdbd37a"}[chunkId] + ".js";
};